export const locale = ({ locale }) => {
  return locale;
};

export const lang = ({ locale }) => {
  if (!locale) {
    return "ro";
  }

  return locale.split("_")[0];
};

export const deals = ({ deals }) => {
  return deals;
};

export const isSubheaderVisible = ({ layout }) => {
  return layout.subheader.visible;
};

export const isPrimaryChatVisible = ({ layout }) => {
  return layout.chat.primary.visible;
};

export const isSecondaryChatVisible = ({ layout }) => {
  return layout.chat.secondary.visible;
};
